/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Override_PlaceholderInputs */



/**
* | output |
* | --- |
* | "Explain why this table result is being overridden..." |
*
* @param {Override_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const override_placeholder = /** @type {((inputs?: Override_PlaceholderInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Override_PlaceholderInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Expliquez pourquoi le résultat de cette table est modifié...")
	if (locale === "es") return /** @type {LocalizedString} */ ("Explique por qué se está anulando este resultado de mesa...")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Explique por que o resultado desta mesa está sendo substituído...")
	if (locale === "it") return /** @type {LocalizedString} */ ("Spiega perché il risultato di questo tavolo viene sovrascritto...")
	return /** @type {LocalizedString} */ ("Explain why this table result is being overridden...")
});